/**
 * Flip an object's keys and values.
 * e.g. {a: 'x', b: 'y'} → {x: 'a', y: 'b'}
 */
export function objectFlip(obj: Record<string, string>): Record<string, string> {
	return Object.entries(obj).reduce(
		(acc: Record<string, string>, [key, value]) => ((acc[value] = key), acc),
		{}
	);
}
